import { placesAutocomplete, placeDetails } from './db.js';
import { escapeHtml } from './ui.js';

// Google Places autocomplete, attached to any address text input. On pick it
// fills the input with the formatted address and updates `meta` (lat/lng/placeId/
// postcode); a manual edit clears the geocode so a stale pin can't linger. The
// input must sit inside a `.fc-picker` with a sibling `.fc-dropdown` (see the
// markup callers use). Predictions come from the server-side proxy — no key or
// map script in the browser.
//
// Returns { meta } — read meta.lat/meta.lng/meta.placeId when saving.
export function attachPlacesAutocomplete(input, drop, { onSelect, initial } = {}) {
  const meta = {
    lat: (initial && initial.lat) ?? null,
    lng: (initial && initial.lng) ?? null,
    placeId: (initial && initial.placeId) ?? null,
    postcode: (initial && initial.postcode) ?? null,
  };
  if (!input || !drop) return { meta };
  let seq = 0, token = null, debounce = null;
  const hide = () => { drop.hidden = true; drop.innerHTML = ''; };
  const search = async (q) => {
    const my = ++seq;
    if (!token) token = `${Date.now()}-${Math.random().toString(36).slice(2)}`; // one billable session per address
    let list = [];
    try { list = await placesAutocomplete(q, token); } catch (_) { hide(); return; }
    if (my !== seq) return; // a newer keystroke already superseded this
    if (!list.length) { hide(); return; }
    drop.innerHTML = list.slice(0, 6).map((s, i) => `<button type="button" class="fc-opt" data-i="${i}"><span>${escapeHtml(s.main || s.text)}</span><span class="sec">${escapeHtml(s.secondary || '')}</span></button>`).join('');
    drop.hidden = false;
    drop.querySelectorAll('.fc-opt').forEach((b) => b.addEventListener('click', async () => {
      const pick = list[+b.dataset.i]; if (!pick) return;
      input.value = pick.text; hide();
      try {
        const det = await placeDetails(pick.placeId, token);
        if (det) {
          input.value = det.address || input.value;
          meta.lat = det.lat; meta.lng = det.lng; meta.placeId = det.placeId; meta.postcode = det.postcode || null;
          if (onSelect) onSelect(det);
        }
      } catch (_) { /* keep the prediction text if details fail */ }
      token = null; // the session ends with the details fetch
    }));
  };
  input.addEventListener('input', () => {
    meta.lat = null; meta.lng = null; meta.placeId = null; meta.postcode = null; // typing invalidates the pin
    const q = input.value.trim();
    clearTimeout(debounce);
    if (q.length < 3) { hide(); return; }
    debounce = setTimeout(() => search(q), 280);
  });
  input.addEventListener('blur', () => setTimeout(hide, 180)); // let a click land first
  return { meta };
}
